import EmptyPropertyValue from './EmptyPropertyValue';
import StyledValue from './StyledValue';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StringPropertyValue({
  propertyName,
  value
}) {
  return /*#__PURE__*/_jsx(StyledValue, {
    "data-test-property-name": propertyName,
    "data-test-property-type": "string",
    "data-test-element-name": "string-property-value",
    title: `${value}`,
    children: value === '' || value == null ? /*#__PURE__*/_jsx(EmptyPropertyValue, {}) : value
  });
}